import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VList,
    {
      staticClass: "pt-0",
      class: _vm.isMini ? "" : "pa-3",
      attrs: { nav: "", dense: "" },
    },
    [
      !_vm.isMini
        ? _c(VSelect, {
            staticClass: "pb-1 menu-main",
            attrs: {
              items: _vm.onFilterMenu,
              "item-text": "name_i18n",
              "item-value": "key",
              rounded: "",
              small: "",
              dense: "",
              "hide-details": "auto",
              solo: "",
              elevation: "1",
              value: null,
              "menu-props": { maxHeight: 504 },
            },
            on: {
              change: function ($event) {
                return _vm.onChangeMenuSelect(_vm.selectionMenu)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-chevron-down"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "item",
                  fn: function (ref) {
                    var active = ref.active
                    var item = ref.item
                    var attrs = ref.attrs
                    var on = ref.on
                    return [
                      _c(
                        VListItem,
                        _vm._g(
                          _vm._b(
                            {
                              attrs: { id: item.key, name: item.key },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var active = ref.active
                                      return [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(
                                              VListItemTitle,
                                              [
                                                _c(
                                                  VRow,
                                                  {
                                                    attrs: {
                                                      "no-gutters": "",
                                                      align: "center",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(_vm.$t(item.key))
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "v-list-item",
                            attrs,
                            false
                          ),
                          on
                        )
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              876698949
            ),
            model: {
              value: _vm.selectionMenu,
              callback: function ($$v) {
                _vm.selectionMenu = $$v
              },
              expression: "selectionMenu",
            },
          })
        : _vm._e(),
      _vm.isMini
        ? _c(
            VMenu,
            {
              attrs: { bottom: "", "offset-x": true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          VBtn,
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "mb-1 mt-2",
                                attrs: {
                                  color: "",
                                  fab: "",
                                  solo: "",
                                  elevation: "3",
                                  small: "",
                                  dense: "",
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-menu-open"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3534729857
              ),
            },
            [
              _c(
                VList,
                _vm._l(_vm.menu_aux, function (item, index) {
                  return _c(
                    VListItem,
                    {
                      key: index,
                      class:
                        item.key == _vm.selectionMenu
                          ? "primary--text v-list-item--active theme--light"
                          : "",
                      attrs: { "active-class": "primary--text" },
                      on: {
                        click: function ($event) {
                          return _vm.onChangeMenu(item)
                        },
                      },
                    },
                    [_c(VListItemTitle, [_vm._v(_vm._s(item.name_i18n))])],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { key: _vm.key_menu },
        [
          _vm.requireRole(_vm.getSelectedMenu()) &&
          _vm.checkFlags(_vm.getSelectedMenu())
            ? _c("nav-menu", {
                attrs: {
                  menu: _vm.getSelectedMenu().items,
                  isMini: _vm.isMini,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("hub-ia-migration-dialog", {
        ref: "hub_ia_dialog",
        on: { select: _vm.onHubIaSelect, dismiss: _vm.restoreMenuSelection },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }